{
    "$comment": [
        "ADR-0032 Part 3, gate item 2 + gate item 3 (ENG-9684). THE single recorded source",
        "for the addresses Composio's per-key IP allowlist is expected to hold. Read by BOTH",
        "scripts/fleet-egress-enum.sh (the operator's pre-arming instrument) and the",
        "ComposioEgressAddressDrift cron (the between-armings watch). They must agree, which",
        "is why neither carries its own copy.",
        "",
        "WHY A REPO FILE AND NOT SSM. Composio's allowlist has no read API, so its contents",
        "can never be queried - only inferred from a refusal. This file is therefore not a",
        "cache of vendor state; it is a DECLARATION of what a human pasted into a dashboard.",
        "A PR is the right ceremony for changing a security boundary nobody can read back.",
        "SSM would also hit registerCron's five-parameter grant scope (ENG-9940), where a",
        "sixth parameter fails silently.",
        "",
        "THE COMPARISON IS ON `ip` AND NOTHING ELSE. `seenAsGateway` is informational. A NAT",
        "rebuild that re-adopts the same EIP keeps egress correct while changing the gateway",
        "id, so comparing ids would red on the safe case - which is precisely the case Part 2's",
        "EIP adoption exists to create.",
        "",
        "ANY NEW HOSTS-ACCOUNT EGRESS ADDRESS TURNS THE DETECTOR RED UNTIL IT IS ADDED HERE.",
        "That is the forcing function working, not a fault: ENG-9426's 2b NAT was added in the",
        "same change that created it. Do the same for the next one, or the detector correctly",
        "reports that hosts are leaving from an address no key allows. Do not loosen the check.",
        "A CONTROL-PLANE address gets no such forcing function - the detector never sees that",
        "account at all - which is why the bridge note below is written out by hand instead.",
        "",
        "15.135.204.192 IS GONE AND MUST NOT BE RE-ADDED (ENG-9426, 2026-09-15).",
        "The dev NAT was retired and that address was RELEASED back to the AWS pool, so it can",
        "be reassigned to another AWS customer at any time. An allowlist entry naming it would",
        "then permit a stranger's host rather than simply failing closed. Nothing was armed when",
        "this happened, so no key ever held it - but this file IS what an operator pastes from,",
        "which is why it is removed here the same day.",
        "",
        "WHY retainOnDelete DID NOT SAVE IT, because the next person will assume it would.",
        "The option was added in the SAME change that set dev's natMode to `none`. Pulumi reads",
        "delete-time options from the STATE recorded at the resource's last registration, and by",
        "the time this ran the resource was no longer in the program at all - so the state still",
        "said 'delete normally'. retainOnDelete has to land in a deploy that STILL DECLARES the",
        "resource before it protects anything. The two prod hosts EIPs listed below are protected, because",
        "this apply registered them with the option set.",
        "",
        "THE BRIDGE ADDRESSES ARE RECORDED HERE AND LIVE SOMEWHERE ELSE (ENG-10687).",
        "The two control-plane bridge addresses were allocated by ENG-10515's deploy on",
        "2026-09-18 and are listed below with stage `prod-bridge`. They sit in the CONTROL",
        "PLANE account (109039361030), region us-east-2 - NOT the hosts account, and not",
        "ap-southeast-2. Read back live after that deploy, not predicted.",
        "",
        "SO `account` AND `homeRegion` ABOVE ARE NOT THE SCOPE OF THIS FILE. They are the",
        "single account and region the DETECTOR enumerates, which is why they stayed",
        "hosts-account values when addresses from a second account landed here. Each address",
        "carries its own `account` and `region`; read those, never the top-level pair, when",
        "asking where an address lives.",
        "",
        "THE DETECTOR CANNOT VERIFY THE BRIDGE PAIR, AND THAT IS CORRECT, NOT A BUG.",
        "ComposioEgressAddressDrift enumerates ONE account - the hosts account - so it compares",
        "only the addresses instances there actually route through. The bridge addresses sit in",
        "this set unmatched and unflagged, which costs nothing: the detector reports an OBSERVED",
        "address that is not approved, so a superset can never make it red. Do NOT 'fix' the",
        "asymmetry by trimming this file to what the detector checks - the file records what the",
        "ALLOWLIST must hold, which is a superset of what any one account scan can see.",
        "Trimming it would make the allowlist incomplete, which is a fleet-wide 401 rather than",
        "a tidy file.",
        "",
        "PASTE THE WHOLE SHARED SET, ALWAYS. Composio's field takes explicit comma-delimited",
        "addresses and no CIDR, so a key armed with the hosts pair alone locks out every",
        "server-side call the control plane makes, and one armed with the bridge pair alone locks",
        "out the fleet. This used to read 'PASTE ALL FOUR, ALWAYS', which `orgAddresses` below",
        "makes false: for an org with a BYO host the shared set is NOT the whole value, and an",
        "operator following the old sentence would arm a key that refuses that org's own agents.",
        "",
        "`orgAddresses` - THE SHARED SET IS NOT EVERY ORG'S SET (ENG-10718).",
        "An org whose agents run on a host we do not operate the network for - a BYO host in the",
        "customer's AWS account, or a `self` host on hardware we never see - egresses from an",
        "address no shared entry above carries. These are recorded per org rather than",
        "merged into `addresses`, because they are not fleet-wide: pasting one org's BYO address",
        "into another org's key widens that key for no reason. The drift detector and",
        "fleet-egress-enum.sh both read `addresses` and only `addresses`, so nothing here is ever",
        "compared against a hosts-account scan - which is correct, since these addresses live in",
        "accounts neither ever enumerates.",
        "",
        "AN OBSERVED ADDRESS IS NOT AN APPROVED ONE, AND THAT IS THE WHOLE POINT OF THIS FILE.",
        "`host_attested_egress` (ENG-10666) records the address a BYO host was SEEN calling from,",
        "and it is the only way to learn one - the `augmented-byo-provisioner` role grants neither",
        "`DescribeRouteTables` nor `DescribeNatGateways`, so enumeration cannot answer it. But",
        "seeing an address is not deciding it may hold a key. A row appears here when a human",
        "decides it, in a PR, which is the same ceremony every other entry gets. So an org can",
        "legitimately have a known egress address and no entry here - see Zanda below - and the",
        "posture page must withhold its paste value rather than offer the shared set.",
        "",
        "ZANDA IS THE LIVE EXAMPLE, AND ITS ABSENCE BELOW IS DELIBERATE.",
        "Zanda has an active BYO host - d0a78e4f-7a21-4d8d-85db-66a167fdd8cb in account",
        "585819234046, created 2026-09-16 - and as of 2026-09-20 its egress address IS known:",
        "3.107.131.133, resolved from `host_attested_egress` after an account enumeration failed",
        "to find it (it is a THIRD account, which no census had thought to scan). It is not",
        "recorded because nobody has approved it. That host carries ZERO assigned agents, so it",
        "makes no Composio calls and the omission costs nothing today; the approval queue for",
        "exactly this decision is ENG-10668, unbuilt. The consequence is intended and measured:",
        "Zanda's org IS `fully_managed` (read from prod 2026-09-20), so it holds a",
        "platform-managed Composio key and DOES appear on /admin/composio-key-posture - with no",
        "paste value and a reason. That row is the feature working. Do not 'fix' it by adding",
        "3.107.131.133 below - add the approval.",
        "",
        "THE SAME READ FOUND ZERO `self` HOSTS FLEET-WIDE (2026-09-20), which is why widening the",
        "rule beyond the BYO pointer costs nothing today: exactly two orgs have a host outside our",
        "NATs, both BYO, and only Zanda's lacks a recorded address. Every other org's row is the",
        "shared set, byte-identical to what ENG-10713 already served it. If that ratio ever",
        "inverts - many orgs withholding - the answer is to record addresses or build ENG-10668,",
        "NOT to narrow the rule back."
    ],
    "account": "711726113003",
    "homeRegion": "ap-southeast-2",
    "addresses": [
        {
            "ip": "32.236.6.24",
            "stage": "prod",
            "account": "711726113003",
            "region": "ap-southeast-2",
            "seenAsGateway": "nat-00a3dac969c0641a6",
            "note": "Prod hosts NAT. Measured 2026-09-12 (ENG-10392): 25 of 25 active prod host instances route 0.0.0.0/0 here."
        },
        {
            "ip": "54.253.255.215",
            "stage": "prod",
            "account": "711726113003",
            "region": "ap-southeast-2",
            "seenAsGateway": "nat-04384e27ab04973b5",
            "note": "Prod hosts NAT in ap-southeast-2b, created 2026-09-15 by ENG-9426. The 12 prod hosts in the 2b private subnet egress here instead of crossing to 2a. Verified live after the Pulumi apply, not predicted."
        },
        {
            "ip": "77.112.237.198",
            "stage": "prod-bridge",
            "account": "109039361030",
            "region": "us-east-2",
            "seenAsGateway": "nat-07f1db970d2714b95",
            "note": "Control-plane egress bridge NAT in us-east-2a, created 2026-09-18 by ENG-10515. Carries server-side Composio traffic from the API and the webapp SSR Lambda once COMPOSIO_EGRESS_TRANSPORT reads `bridge`; until then the bridge function is never invoked and this address sends nothing. Verified live after the deploy: attached to the gateway, state available, and matching /augmented/prod/secrets/COMPOSIO_EGRESS_IPS."
        },
        {
            "ip": "18.224.120.114",
            "stage": "prod-bridge",
            "account": "109039361030",
            "region": "us-east-2",
            "seenAsGateway": "nat-02a4721d4ce678cf7",
            "note": "The us-east-2b half of the same managed multi-AZ NAT. Two addresses is what `az: 2` costs on the allowlist, accepted deliberately in ENG-9684: adding an address AFTER arming is a blind hand edit of every key with production 401s as the only completion signal."
        }
    ],
    "orgAddresses": {
        "a4bba5c8-f664-46fe-a894-c95679c615ac": {
            "orgSlug": "integritylabs",
            "addresses": [
                {
                    "ip": "54.153.194.237",
                    "stage": "prod-byo",
                    "account": "436812233703",
                    "region": null,
                    "seenAsGateway": "nat-0c3cc231a8701a0e9",
                    "note": "The BYO \"Agents\" account's NAT, serving `asha` on prod-integritylabs-integritylabs-4. Measured 2026-09-19 (ENG-10718) and again in the 24h /host/* census on 2026-09-20: 55,109 requests from 32 distinct paths. `region` is null because it is NOT RECORDED and cannot be enumerated from here - see the $comment; the comparison is on `ip` alone, so a null costs nothing, whereas a guessed region would be a fact this file states without evidence. THIS ORG WAS ARMED DURING THE GATE 5 REHEARSAL (ENG-10712) WITHOUT THIS ADDRESS. It passed only because nothing on that host called Composio inside the ~15-minute window; had it, the call would have been refused."
                }
            ]
        }
    }
}
